<script setup lang="ts">
import type { BagAllowance } from '@optionway/models';
import { Check, X } from 'lucide-vue-next';

const properties = defineProps<BagAllowance>();

const prefix = 'components.results.luggageDescription';

const dimensions = computed(() => formatDimensions(properties));
</script>

<template>
  <!-- Icon + Count -->
  <div class="mr-2 flex items-center gap-1">
    <span class="text-sm font-medium">{{ properties.pieces }}</span>
    <component
      :is="usePascalCase(`SvgoResultsLuggageDescription${properties.type}Bag`)"
      class="h-5 w-5"
      filled
      aria-hidden="true"
      :font-controlled="false"
    />
  </div>

  <!-- Dimension / Weight -->
  <div class="flex flex-col">
    <div class="flex-1 text-base">
      {{ $t(`${prefix}.${useCamelCase(properties.type)}Bag`) }}
    </div>
    <div
      v-if="dimensions || properties.weight"
      class="flex items-center space-x-2"
    >
      <div v-if="dimensions">{{ dimensions }}</div>
      <div
        v-if="properties.weight"
        class="flex items-center space-x-2"
      >
        <div
          v-if="dimensions"
          class="h-1 w-1 rounded-full bg-border"
        />
        <div>({{ properties.weight }}kg)</div>
      </div>
    </div>
  </div>

  <!-- Included / Not included -->
  <div class="ml-auto flex items-center space-x-2">
    <div>
      <Check
        v-if="properties.pieces"
        class="h-4 w-4"
        aria-hidden="true"
      />
      <X
        v-else
        class="h-4 w-4"
        aria-hidden="true"
      />
    </div>
    <div class="whitespace-nowrap text-sm">
      {{ properties.pieces ? $t(`${prefix}.included`) : $t(`${prefix}.notIncluded`) }}
    </div>
  </div>
</template>
